import styled from 'styled-components';

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
`;
